/** 主题变化事件 */
export const ThemeChangedEvent = 'themeChanged'
